/**
 * Inayah — "stick to bottom" product details column.
 *
 * On the PDP the image gallery (left) is usually much taller than the details column
 * (right). We want the details to scroll to the bottom of their own content on the first
 * scroll, then PIN to the bottom of the viewport (with a little spacing) while the gallery
 * keeps scrolling — instead of leaving a long stretch of white space.
 *
 * Pure CSS `position: sticky; bottom:` does not do this for a column that starts at the
 * top of a tall row (it just scrolls away). The reliable trick for a sidebar TALLER than
 * the viewport is `position: sticky; top: (viewportHeight - contentHeight - spacing)`,
 * which pins the element once its BOTTOM reaches the viewport bottom. The content height
 * varies per product, so we compute it here.
 *
 * For short details (shorter than the viewport) we fall back to the theme's normal
 * sticky-top offset, so they pin to the top as before.
 */
(function () {
  'use strict';

  var BOTTOM_SPACING = 24; // px of breathing room below the pinned details
  var DESKTOP_MQ = '(min-width: 750px)';

  function init() {
    var content = document.querySelector('.product-grid__item--content-wrapper.product-grid__sticky');
    if (!content) return;
    var media = document.querySelector('.product-grid__item--media-wrapper.product-grid__sticky');

    // The theme's default sticky offset (header height + spacing). Read it from the media
    // column, which keeps its normal sticky-top, so we stay in sync if the header resizes.
    function headerOffset() {
      var v = media ? parseFloat(getComputedStyle(media).insetBlockStart) : NaN;
      return isFinite(v) ? v : 72;
    }

    function update() {
      if (!window.matchMedia(DESKTOP_MQ).matches) {
        // Mobile: columns stack, so the sticky offset is irrelevant — let the theme handle it.
        content.style.removeProperty('top');
        return;
      }
      var viewportH = window.innerHeight;
      var contentH = content.offsetHeight;
      // Pin so the details' bottom lands BOTTOM_SPACING above the viewport bottom; but never
      // lower than the header offset (so short details still pin to the top).
      var top = Math.min(headerOffset(), viewportH - contentH - BOTTOM_SPACING);
      content.style.top = top + 'px';
    }

    update();
    window.addEventListener('resize', update, { passive: true });

    // Re-measure if the details height changes (e.g. the Fit Notes / Shipping accordions open).
    if (window.ResizeObserver) {
      try { new ResizeObserver(update).observe(content); } catch (e) {}
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
